import { TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY } from '@monorepo/types';

export type TFactoryProductLineEfficiencyState = {
  factoryLineEfficiencyInfo: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY | null;
};

export const TFactoryProductLineEfficiencyActionType = {
  GetFactoryProductLineEfficiency: 'GET_FACTORY_PRODUCT_LINE_EFFICIENCY' as const,
  GetFactoryProductLineEfficiencySuccess: 'GET_FACTORY_PRODUCT_LINE_EFFICIENCY_SUCCESS' as const,
  GetFactoryProductLineEfficiencyFailure: 'GET_FACTORY_PRODUCT_LINE_EFFICIENCY_FAILURE' as const,
  DeleteFactoryProductLineEfficiency: 'DELETE_FACTORY_PRODUCT_LINE_EFFICIENCY' as const,
  DeleteFactoryProductLineEfficiencyFailure: 'DELETE_FACTORY_PRODUCT_LINE_EFFICIENCY_FAILURE' as const,
};
